/* eu-fit v2 — make product photos read the same size in a grid.
   Supplier photos are padded inconsistently (the product fills 44–100% of the picture), so each
   grid image is measured once on a 96px canvas (non-white "ink" box, shadow-trimmed) and then
   scaled/centred with a transform so the product fills TARGET of its own box. Pure presentation:
   no files change, transforms only, no layout shift. Cached per image in sessionStorage.
   Kill switch: window.EU_FIT.disabled = true, or ?eufit=0 in the URL (for before/after checks). */
(function (w, d) {
  var CFG = w.EU_FIT = Object.assign({
    target: 0.84, minScale: 0.75, maxScale: 1.5, sample: 96, white: 240, alpha: 24, trim: 0.005,
    minInkArea: 0.06, upgradeAt: 1.1, rootMargin: '300px',
    frame: '.snize-thumbnail, .jfy__pi-w, .product-item__image-wrapper .aspect-ratio, [data-eu-fit-frame]',
    selector: '.snize-search-results-content .snize-item-image, img.jfy__pi, .product-item__primary-image, .product-item__secondary-image'
  }, w.EU_FIT || {});
  if (CFG.disabled || /[?&]eufit=0(&|$)/.test(w.location.search)) return;

  /* ---------- cache (keyed by URL without the Shopify size suffix, shared by the 480/720 variants) */
  var KEY = 'eu-fit-v2', cache = new Map(), dirty = false;
  function ck(url) { return url.replace(/_(large|medium|small|grande|\d+x\d*)(\.[a-z]+)(\?|$)/i, '$2$3'); }
  try { var raw = JSON.parse(sessionStorage.getItem(KEY) || '[]'); raw.forEach(function (e) { cache.set(e[0], e[1]); }); } catch (e) {}
  function persist() {
    if (!dirty) return; dirty = false;
    try { var arr = []; cache.forEach(function (v, k) { arr.push([k, v]); }); if (arr.length > 800) arr = arr.slice(arr.length - 800); sessionStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  var persistT = null; function schedulePersist() { dirty = true; clearTimeout(persistT); persistT = setTimeout(persist, 1000); }

  /* ---------- measurement: bounding box of non-white pixels, edges carrying <trim of the ink mass dropped (soft shadows) */
  function inkBox(im) {
    var W = CFG.sample, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
    var cv = d.createElement('canvas'); cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d', { willReadFrequently: true }); ctx.drawImage(im, 0, 0, W, H);
    var px = ctx.getImageData(0, 0, W, H).data, rows = new Float32Array(H), cols = new Float32Array(W), total = 0;
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
      var i = (y * W + x) * 4; if (px[i + 3] <= CFG.alpha) continue;
      var v = (px[i] + px[i + 1] + px[i + 2]) / 3; if (v >= CFG.white) continue;
      var m = (CFG.white - v) / CFG.white; rows[y] += m; cols[x] += m; total += m;
    }
    if (!total) return null;
    var lim = total * CFG.trim, acc, x0 = 0, x1 = W - 1, y0 = 0, y1 = H - 1;
    for (acc = 0; x0 < W && acc + cols[x0] < lim; x0++) acc += cols[x0];
    for (acc = 0; x1 > x0 && acc + cols[x1] < lim; x1--) acc += cols[x1];
    for (acc = 0; y0 < H && acc + rows[y0] < lim; y0++) acc += rows[y0];
    for (acc = 0; y1 > y0 && acc + rows[y1] < lim; y1--) acc += rows[y1];
    var box = { l: x0 / W, t: y0 / H, w: (x1 - x0 + 1) / W, h: (y1 - y0 + 1) / H };
    if (box.w * box.h < CFG.minInkArea) return null; /* a lone dark detail on a white product: leave it alone */
    return { l: +box.l.toFixed(3), t: +box.t.toFixed(3), w: +box.w.toFixed(3), h: +box.h.toFixed(3) };
  }
  var queue = [], pumping = false;
  function pump() {
    if (pumping) return; pumping = true;
    (w.requestAnimationFrame || setTimeout)(function () {
      var n = 0; while (queue.length && n++ < 4) { var job = queue.shift(); try { job.res(inkBox(job.im)); } catch (e) { job.res(null); } }
      pumping = false; if (queue.length) pump();
    });
  }
  function measure(url) {
    var k = ck(url); if (cache.has(k)) return Promise.resolve(cache.get(k));
    return new Promise(function (res) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      var done = function (v) { cache.set(k, v); schedulePersist(); res(v); };
      im.onload = function () { var go = function () { queue.push({ im: im, res: done }); pump(); }; if (im.decode) im.decode().then(go, go); else go(); };
      im.onerror = function () { done(null); };
      im.src = url;
    });
  }

  /* ---------- base transform: the stylesheet may ALREADY position the image with a transform
     (Warehouse centres .aspect-ratio photos with top/left 50% + translate(-50%,-50%), e.g. the PDP
     "You may also like" rail). Overriding it dropped the centring and left one corner of the photo
     in the frame (2026-09-21). Read the stylesheet's own translation - with ours lifted and
     transitions frozen so the value is not mid-animation - and ADD the fit on top of it. A base
     that scales / rotates is someone else's effect: leave that image alone. */
  function baseShift(img) {
    var st = img.style, had = st.getPropertyValue('transform'), hadP = st.getPropertyPriority('transform');
    var tr = st.getPropertyValue('transition'), trP = st.getPropertyPriority('transition');
    st.setProperty('transition', 'none', 'important');
    if (had) st.removeProperty('transform');
    var t = w.getComputedStyle(img).transform, out = { x: 0, y: 0, ok: true };
    if (had) st.setProperty('transform', had, hadP);
    if (tr) st.setProperty('transition', tr, trP); else st.removeProperty('transition');
    if (t && t !== 'none') {
      var m = /^matrix\(([^)]+)\)$/.exec(t), v = m ? m[1].split(',').map(parseFloat) : null;
      if (v && v.length === 6 && Math.abs(v[0] - 1) < 0.001 && Math.abs(v[3] - 1) < 0.001 && Math.abs(v[1]) < 0.001 && Math.abs(v[2]) < 0.001) { out.x = v[4]; out.y = v[5]; }
      else out.ok = false;
    }
    return out;
  }

  /* ---------- apply: maths on the image's own layout box; the frame only clips */
  function apply(img, ink) {
    var bw = img.clientWidth, bh = img.clientHeight, nw = img.naturalWidth, nh = img.naturalHeight;
    if (!bw || !bh || !nw || !nh) return false;
    var bs = baseShift(img);
    if (!bs.ok) { img.style.removeProperty('transform'); img.dataset.euFitW = bw; return true; }
    var base = Math.min(bw / nw, bh / nh), dw = nw * base, dh = nh * base; /* object-fit: contain inside the box */
    var s = Math.min(bw * CFG.target / (dw * ink.w), bh * CFG.target / (dh * ink.h));
    s = Math.max(CFG.minScale, Math.min(CFG.maxScale, s));
    var cx = (bw - dw) / 2 + dw * (ink.l + ink.w / 2) - bw / 2; /* ink centre vs box centre, before scaling */
    var cy = (bh - dh) / 2 + dh * (ink.t + ink.h / 2) - bh / 2;
    img.style.setProperty('transform-origin', '50% 50%', 'important');
    img.style.setProperty('transform', 'translate(' + (bs.x - cx * s).toFixed(1) + 'px,' + (bs.y - cy * s).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')', 'important');
    img.dataset.euFit = s.toFixed(2); img.dataset.euFitW = bw;
    var frame = (img.closest && img.closest(CFG.frame)) || img.parentElement; if (frame) frame.style.overflow = 'hidden';
    /* sharpen only when the scaled image would exceed the 480px thumb on this screen: 720 variant via srcset (browser picks per DPR) */
    var need = (w.devicePixelRatio || 1) * bw * s, src = img.currentSrc || img.src;
    if (need > 480 * CFG.upgradeAt && /_large\.(jpe?g|png|webp)/i.test(src) && !img.srcset) {
      img.sizes = Math.round(bw * s) + 'px';
      img.srcset = src + ' 480w, ' + src.replace(/_large\.(jpe?g|png|webp)/i, '_720x720.$1') + ' 720w';
    }
    return true;
  }

  function fit(img) {
    if (img.dataset.euFitBusy) return;
    var src = img.currentSrc || img.src;
    if (!src || /^data:|\.svg(\?|$)/i.test(src)) return;
    if (img.dataset.euFitDone && img.dataset.euFitSrc === ck(src) && +img.dataset.euFitW === img.clientWidth) return;
    img.dataset.euFitBusy = '1';
    var run = function () {
      measure(img.currentSrc || img.src).then(function (ink) {
        delete img.dataset.euFitBusy;
        if (!img.clientWidth) { return; } /* not laid out (hidden tab, mid-render): try again on the next scan */
        img.dataset.euFitSrc = ck(img.currentSrc || img.src);
        if (ink) { if (apply(img, ink)) img.dataset.euFitDone = '1'; }
        else { img.style.removeProperty('transform'); img.dataset.euFitDone = '1'; }
      });
    };
    if (img.complete && img.naturalWidth) run();
    else { img.addEventListener('load', run, { once: true }); img.addEventListener('error', function () { delete img.dataset.euFitBusy; }, { once: true }); }
  }

  /* ---------- discovery: IntersectionObserver near the viewport, MutationObserver for widget re-renders (coalesced per frame) */
  var io = 'IntersectionObserver' in w ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) fit(e.target); }); }, { rootMargin: CFG.rootMargin }) : null;
  function scan() {
    d.querySelectorAll(CFG.selector).forEach(function (img) {
      if (img.dataset.euFitSeen) { if (img.dataset.euFitDone && img.dataset.euFitSrc !== ck(img.currentSrc || img.src)) { delete img.dataset.euFitDone; img.style.removeProperty('transform'); if (io) io.observe(img); else fit(img); } return; }
      img.dataset.euFitSeen = '1'; if (io) io.observe(img); else fit(img);
    });
  }
  var scanQueued = false;
  function queueScan() { if (scanQueued) return; scanQueued = true; (w.requestAnimationFrame || setTimeout)(function () { scanQueued = false; scan(); }); }
  w.euFitScan = queueScan;
  function start() {
    scan();
    new MutationObserver(queueScan).observe(d.body, { childList: true, subtree: true });
    var rt; w.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { d.querySelectorAll('[data-eu-fit-done]').forEach(function (img) { if (+img.dataset.euFitW !== img.clientWidth) { delete img.dataset.euFitDone; fit(img); } }); }, 200); });
    d.addEventListener('mouseover', function (e) { var t = e.target; if (t && t.classList && t.classList.contains('snize-thumbnail')) t.querySelectorAll('.snize-flip-image').forEach(fit); }, true);
    w.addEventListener('pagehide', persist);
  }
  if (d.body) start(); else d.addEventListener('DOMContentLoaded', start);
})(window, document);
